export const MINIMUM_REASON_LENGTH = 10;

const RANDOM_RADIX = 36;
const RANDOM_PREFIX_LENGTH = 2;

export const buildBatchKey = () =>
    [Date.now(), Math.random().toString(RANDOM_RADIX).slice(RANDOM_PREFIX_LENGTH)].join('-');

export const entryKeyOf = (batchKey, entryId) => [batchKey, entryId].join('-');

export const messageOf = (requestError, fallback) =>
    (requestError && requestError.response && requestError.response.data && requestError.response.data.message) || fallback;
